import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  Signal,
} from '@angular/core';
import {
  ButtonComponent,
  ContentComponent,
  SingleCardLayoutComponent,
} from '@lyceo/shared/ui';
import { AuthFacade } from '@lyceo/shared/auth/data-access';
import { TranslocoDirective } from '@jsverse/transloco';
import {
  ButtonFill,
  ButtonSize,
  ComponentStatus,
} from '@lyceo/shared/util-models';
import { LogoComponent } from '@lyceo/homi/shared/ui';
import { LoginSettingsFacade } from '@lyceo/homi/login/data-access';
import { Capacitor } from '@capacitor/core';

@Component({
  selector: 'lib-homi-login-page',
  imports: [
    ButtonComponent,
    ContentComponent,
    SingleCardLayoutComponent,
    TranslocoDirective,
    LogoComponent,
  ],
  templateUrl: './login-page.component.html',
  styleUrl: './login-page.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoginPageComponent {
  private readonly authFacade: AuthFacade = inject(AuthFacade);
  private readonly loginSettingsFacade: LoginSettingsFacade =
    inject(LoginSettingsFacade);

  protected readonly ButtonSize: typeof ButtonSize = ButtonSize;
  protected readonly ButtonFill: typeof ButtonFill = ButtonFill;
  protected readonly ComponentStatus: typeof ComponentStatus = ComponentStatus;

  protected readonly website: Signal<string | undefined> =
    this.loginSettingsFacade.website;
  protected readonly clearWebsiteAvailable: Signal<boolean> = computed(() => {
    return (
      Capacitor.getPlatform() !== 'web' && this.loginSettingsFacade.websiteSet()
    );
  });

  public login(): void {
    this.authFacade.login();
  }

  public clearWebsite(): void {
    this.loginSettingsFacade.clearWebsite();
  }
}
